import { useLeadShifts } from 'queries/shift'
import { QueryData } from 'queries/types'
import { Box, Card, Link, Pluralize } from '@workwhile/ui'
import { ShiftDetailProvider } from '../ShiftDetailProvider'
import { useAuthContext } from 'components/auth'
import { ShiftLeadRows } from './ShiftLeadRows'

interface Props {
  leadShift: Pick<
    QueryData<typeof useLeadShifts>['leadShifts'][number],
    'id' | 'workersNeeded'
  >
}

export const LeadShiftCard = ({ leadShift }: Props) => {
  const numLeadsOnShift = leadShift.workersNeeded
  const { company } = useAuthContext()

  return (
    <Card borderWidth={0}>
      {company ? (
        <ShiftDetailProvider
          key={`lead-shift-${leadShift.id}-rows`}
          companyId={company.id}
          shiftId={leadShift.id}
        >
          <ShiftLeadRows />
        </ShiftDetailProvider>
      ) : null}
      <Box key={`lead-shift-${leadShift.id}-link`}>
        <Link to={`/shift/${leadShift.id}`}>
          View Shift{' '}
          <Pluralize
            hideCount
            count={numLeadsOnShift}
            oneText="Lead's"
            manyText="Leads'"
          />{' '}
          shift
        </Link>
      </Box>
    </Card>
  )
}
